import axios from "@axios";

const DEFAULT_STATE = {
  partners: [],
  partnerViews: [],
  brands: [],
  billings: [],
  cashings: [],
  partnerList: [],
  partnerCurrencyList: [],
  partnerNatureList: [],
  billingList: [],
  cashingList: [],
  // Exports
  dates: [],
  export: "",
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getPartners: (state) => state.partners,
    getPartnerViews: (state) => state.partnerViews,
    getBrands: (state) => state.brands,
    getBillings: (state) => state.billings,
    getCashings: (state) => state.cashings,
    getPartnerList: (state) => state.partnerList,
    getPartnerCurrencyList: (state) => state.partnerCurrencyList,
    getPartnerNatureList: (state) => state.partnerNatureList,
    getBillingList: (state) => state.billingList,
    getCashingList: (state) => state.cashingList,
    // Exports:
    getDates: (state) => state.dates,
    getExport: (state) => state.export,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setPartners(state, payload) {
      state.partners = payload;
    },
    setPartnerViews(state, payload) {
      state.partnerViews = payload;
    },
    setBrands(state, payload) {
      state.brands = payload;
    },
    setBillings(state, payload) {
      state.billings = payload;
    },
    setCashings(state, payload) {
      state.cashings = payload;
    },
    setPartnerList(state, payload) {
      state.partnerList = payload;
    },
    setPartnerCurrencyList(state, payload) {
      state.partnerCurrencyList = payload;
    },
    setPartnerNatureList(state, payload) {
      state.partnerNatureList = payload;
    },
    setBillingList(state, payload) {
      state.billingList = payload;
    },
    setCashingList(state, payload) {
      state.cashingList = payload;
    },
    // Exports:
    setDates(state, payload) {
      state.dates = payload;
    },
    setExport(state, payload) {
      state.export = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updatePartners({ commit }, payload) {
      commit("setPartners", payload);
    },
    updatePartnerViews({ commit }, payload) {
      commit("setPartnerViews", payload);
    },
    updateBrands({ commit }, payload) {
      commit("setBrands", payload);
    },
    updateBillings({ commit }, payload) {
      commit("setBillings", payload);
    },
    updateCashings({ commit }, payload) {
      commit("setCashings", payload);
    },
    async getPartnerList({ commit }) {
      const {
        data: { items },
      } = await axios.get("/partners/full_list");
      commit("setPartnerList", items);

      return items;
    },
    async getPartnerCurrencyList({ commit }) {
      const {
        data: { items },
      } = await axios.get("/partners/currencies");
      commit("setPartnerCurrencyList", items);

      return items;
    },
    async getPartnerNatureList({ commit }) {
      const {
        data: { items },
      } = await axios.get("/partners/natures");
      commit("setPartnerNatureList", items);

      return items;
    },
    async getBillingList({ commit }) {
      const {
        data: { items },
      } = await axios.get("/partners/billing_entities");
      commit("setBillingList", items);

      return items;
    },
    async getCashingList({ commit }) {
      const {
        data: { items },
      } = await axios.get("/partners/cashing_entities");
      commit("setCashingList", items);

      return items;
    },
    // Exports
    updateDates({ commit }, payload) {
      commit("setDates", payload);
    },
    updateExport({ commit }, payload) {
      commit("setExport", payload);
    },
  },
};
